import { FC } from 'react';
import ListGroup from 'react-bootstrap/ListGroup';
import Icon from '../Icon/Icon';
import Label from '../Label';
import Action from '../Action/Action';
import styles from './ListItem.module.css';
import cn from 'classnames';

interface ContentItem {
  key: string;
  value: string | null;
}

interface ListItemProps {
  imageUrl: string | null;
  content: ContentItem[];
  id: string;
  onEditClick?: (id: string) => void;
  onDeleteClick?: (id: string) => void;
}

const ListItem: FC<ListItemProps> = ({
  imageUrl,
  content,
  id,
  onEditClick,
  onDeleteClick,
}) => {
  return (
    <ListGroup.Item as="li" className={cn(styles.listItem)} action>
      <Icon imageUrl={imageUrl ?? ''} />
      <div>
        {content.map((item, index) => (
          <div key={index} className={cn(styles.content)}>
            <Label content={`${item.key}:`} bold />
            <Label content={item.value ?? ''} />
          </div>
        ))}
      </div>
      <div className={cn(styles.actions)}>
        <Action
          type="edit"
          size="sm"
          onClick={() => onEditClick && onEditClick(id)}
        />
        <Action
          type="delete"
          size="sm"
          onClick={() => onDeleteClick && onDeleteClick(id)}
        />
      </div>
    </ListGroup.Item>
  );
};

export default ListItem;
